import React, { useEffect, useState } from 'react'
import { Card, Spin, Statistic, Table, Tag, Typography, message } from 'antd'

export default function CaptainDashboard({ fetchData, title }) {
  const [loading, setLoading] = useState(true)
  const [data, setData] = useState(null)

  useEffect(() => {
    let cancelled = false
    async function run() {
      setLoading(true)
      try {
        const d = await fetchData()
        if (!cancelled) setData(d)
      } catch (e) {
        console.error(e)
        if (!cancelled) message.error('تعذر تحميل لوحة الكابتن')
      } finally {
        if (!cancelled) setLoading(false)
      }
    }
    run()
    return () => { cancelled = true }
  }, [fetchData])

  if (loading) return <div style={{ padding: 24 }}><Spin /></div>
  if (!data) return null

  const columns = [
    {
      title: 'النوع',
      dataIndex: 'type',
      key: 'type',
      width: 100,
      render: v => v === 'off_platform'
        ? <Tag color="orange">خارجي</Tag>
        : <Tag color="blue">شركتنا</Tag>,
      filters: [
        { text: 'شركتنا', value: 'platform' },
        { text: 'خارجي', value: 'off_platform' },
      ],
      onFilter: (value, record) => (record.type || 'platform') === value,
    },
    { title: 'رقم الطلب', dataIndex: 'orderId', key: 'orderId', width: 100, sorter: (a, b) => a.orderId - b.orderId },
    {
      title: 'المتجر / المنطقة',
      key: 'shopZone',
      render: (_, r) => {
        if (r.type !== 'off_platform') return '—'
        const parts = []
        if (r.shopName) parts.push(r.shopName)
        if (r.deliveryLocationName) parts.push(r.deliveryLocationName)
        return parts.length ? parts.join(' — ') : '—'
      },
    },
    { title: 'تاريخ الاستلام', dataIndex: 'claimedAt', key: 'claimedAt', width: 180, sorter: (a, b) => String(a.claimedAt).localeCompare(String(b.claimedAt)), defaultSortOrder: 'descend' },
    { title: 'إجمالي الزبون', dataIndex: 'customerTotal', key: 'customerTotal', render: v => v == null ? '—' : v },
    { title: 'رسوم التوصيل', dataIndex: 'deliveryFee', key: 'deliveryFee' },
  ]

  return (
    <div dir="rtl" style={{ maxWidth: 1200, margin: '24px auto', padding: '0 12px' }}>
      <Typography.Title level={3}>
        {title || `لوحة الكابتن — ${data.captain?.name || '-'}`}
      </Typography.Title>

      <div style={{ marginBottom: 16 }}>
        <Card>
          <Statistic title="إجمالي عدد الطلبات" value={data.totals?.deliveriesCount ?? 0} />
        </Card>
      </div>

      <Card title="الطلبات">
        <Table
          rowKey={(r) => `${r.type || 'platform'}-${r.orderId}`}
          dataSource={data.orders || []}
          columns={columns}
          pagination={{ pageSize: 25 }}
        />
      </Card>
    </div>
  )
}
